// extracted by mini-css-extract-plugin
export default {"confirem-accept-modal-dialog":"Modals_confirem-accept-modal-dialog__XLrk4","desc-text":"Modals_desc-text__cd75X"};